window.theme = window.theme || {};
window.slate = window.slate || {};
window.yotpo_key = "qRjzERxzAnPvrw5jVYoOZ01YKrUhlKHbOCBekJTz";
window.testcount = 0;
window.cart_promo_code = 'false' === 'true';
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 300;
window.lazySizesConfig.expFactor = 1.5;
window.lazySizesConfig.loadHidden = false;
window.lazySizesConfig.loadMode = 2;
window.lazySizesConfig.preloadAfterLoad = false;
window.promotionProduct = 'false' === 'true';
window.promotionsData = [];
window.promotionsData = JSON.parse('[{"buy":"29200594468939","get":"29271200727115","buy_sku":"BB-KIMCH-O","get_sku":"BB-TONE-O"},{"buy":"28747678023755","get":"29271200727115","buy_sku":"NUTRIFIT-O","get_sku":"BB-TONE-O"},{"buy":"28747678056523","get":"28693010972747","buy_sku":"NUTRIFIT-P","get_sku":"BB-TONE"},{"buy":"28747678089291","get":"29271204364363","buy_sku":"NUTRIFIT-C","get_sku":"BB-TONE-C"},{"buy":"28693054554187","get":"29271200727115","buy_sku":"NUTRIO","get_sku":"BB-TONE-O"},{"buy":"28693054586955","get":"28693010972747","buy_sku":"NUTRIP","get_sku":"BB-TONE"},{"buy":"28693054619723","get":"29271204364363","buy_sku":"NUTRIB","get_sku":"BB-TONE-C"},{"buy":"28747900256331","get":"29271200727115","buy_sku":"FIT-O","get_sku":"BB-TONE-O"},{"buy":"28747900289099","get":"28693010972747","buy_sku":"FIT-P","get_sku":"BB-TONE"},{"buy":"28747900321867","get":"29271204364363","buy_sku":"COMBO","get_sku":"BB-TONE-C"}]');
window.discountAccordion = 'true' === 'true';

(function ($) {
  var $ = jQuery = $;
  slate.utils = {
    defaultTo: function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
  };
  slate.a11y = {
    pageLinkFocus: function pageLinkFocus($element) {
      var focusClass = 'js-focus-hidden';
      $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

      function callback() {
        $element.first().removeClass(focusClass).removeAttr('tabindex');
      }
    },
    focusHash: function focusHash() {
      var hash = window.location.hash;

      if (hash && document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    },
    bindInPageLinks: function bindInPageLinks() {
      $('a[href*=#]').on('click', function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this));
    },
    trapFocus: function trapFocus(options) {
      var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }

      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
      $(document).off('focusin');
      $(document).on(eventName, function (evt) {
        if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
          options.$container.focus();
        }
      });
    },
    removeTrapFocus: function removeTrapFocus(options) {
      var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }

      $(document).off(eventName);
    },
    lockMobileScrolling: function lockMobileScrolling(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }

      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
    unlockMobileScrolling: function unlockMobileScrolling(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }

      $el.off(namespace);
    }
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function createInstance(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
    _onSectionLoad: function _onSectionLoad(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }

      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

      if (!container) {
        return;
      }

      this.createInstance(container);
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      if (!subSection) {
        this._loadSubSections();
      }

      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
    _loadSubSections: function _loadSubSections() {
      if (AOS) {
        AOS.refreshHard();
      }

      $('[data-subsection]').each(function (evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
    _onSectionUnload: function _onSectionUnload(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);

      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
    _onSelect: function _onSelect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function _onDeselect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function _onBlockSelect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function _onBlockDeselect(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
    _findInstance: function _findInstance(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
    _removeInstance: function _removeInstance(id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },
    register: function register(type, constructor) {
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
      $sections.each(function (index, container) {
        this.createInstance(container, constructor);
      }.bind(this));
    }
  });

  theme.checkCartBeforeCheckout = function () {
    autoGwp = 'false' === 'true';

    if (autoGwp) {
      theme.cart._checkCartBeforeCheckout();
    }

    $('.btn-cart-check').trigger('click');
  };

  theme.Currency = function () {
    var moneyFormat = '$';

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = slate.utils.defaultTo(precision, 2);
        thousands = slate.utils.defaultTo(thousands, ',');
        decimal = slate.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  }();

  theme.Images = function () {
    function imageSize(src) {
      if (!src) {
        return '620x';
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    function getSizedImageUrl(src, size) {
      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol
    };
  }();

  slate.Variants = function () {
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      _getCurrentOptions: function _getCurrentOptions() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          }
        });
        currentOptions = this._compact(currentOptions);
        return currentOptions;
      },
      _getVariantFromOptions: function _getVariantFromOptions() {
        var selectedValues = this._getCurrentOptions();

        var variants = this.variants;
        var found = false;
        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;
          selectedValues.forEach(function (option) {
            if (match) {
              match = variant[option.index] === option.value;
            }
          });

          if (match) {
            found = variant;
          }
        });
        return found || null;
      },
      _onSelectChange: function _onSelectChange() {
        var variant = this._getVariantFromOptions();

        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);

        this._updatePrice(variant);

        this._updateSKU(variant);

        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
      _updateImages: function _updateImages(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
      _updatePrice: function _updatePrice(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
      _updateSKU: function _updateSKU(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
      _updateHistoryState: function _updateHistoryState(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
      },
      _updateMasterSelect: function _updateMasterSelect(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
      _compact: function _compact(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];

          if (value) {
            result[resIndex++] = value;
          }
        }

        return result;
      }
    });
    return Variants;
  }();

  slate.rte = {
    wrapTable: function wrapTable() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
    wrapVideo: function wrapVideo() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
      $iframeVideo.each(function () {
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
      $iframeReset.each(function () {
        this.src = this.src;
      });
    }
  };

  theme.Modals = function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
      this.id = id;
      this.$modal = $('#' + id);

      if (!this.$modal.length) {
        return false;
      }

      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
      this.init();
    }

    Modal.prototype.init = function () {
      var $openBtn = $(this.config.open);
      $openBtn.attr('aria-expanded', 'false');
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
      $('body').on('drawerOpen', function () {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function (evt) {
      var externalCall = false;

      if (this.modalIsOpen) {
        return;
      }

      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        this.$activeSource = $(evt.currentTarget);
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.$modal.prepareTransition().addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);

      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;
      slate.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      $('body').trigger('modalOpen.' + this.id);
      this.bindEvents();
    };

    Modal.prototype.close = function () {
      if (!this.modalIsOpen) {
        return;
      }

      $(document.activeElement).trigger('blur');
      this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      var o = this;
      window.setTimeout(function () {
        o.nodes.$parent.removeClass(o.config.bodyClosingClass);
        o.$modal.removeClass(o.config.closingClass);
      }, 500);

      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;
      slate.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false').focus();
      }

      $('body').trigger('modalClose.' + this.id);
      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      this.nodes.$parent.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        this.$modal.on('click.modal', this.close.bind(this));
        this.nodes.$modalContent.on('click.modal', function (evt) {
          evt.stopImmediatePropagation();
        });
      }
    };

    Modal.prototype.unbindEvents = function () {
      this.nodes.$parent.off('.modal');

      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };

    return Modal;
  }();

  theme.Drawers = function () {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
      this.$drawer = $('#' + id);

      if (!this.$drawer.length) {
        return false;
      }

      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    }

    ;
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function init() {
        var $openBtn = $(this.config.open);
        $openBtn.attr('aria-expanded', 'false');
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
      },
      open: function open(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          this.$activeSource = $(evt.currentTarget);
        }

        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
        slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
        $('body').trigger('drawerOpen.' + this.config.id);

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'true');
        }

        $(".popup-email").addClass("cart-drawer-opened");

        if (this.config.id == 'CartDrawer') {
          history.pushState({}, '', '');
        }

        this.bindEvents();
      },
      close: function close() {
        if (!this.isOpen) {
          return;
        }

        $(document.activeElement).trigger('blur');
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        var o = this;
        window.setTimeout(function () {
          o.$nodes.parent.removeClass(o.config.closingClass);
        }, 500);
        this.isOpen = false;
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false');
        }

        $(".popup-email").removeClass("cart-drawer-opened");

        if (this.config.id == 'CartDrawer') {
          history.back();
        }

        this.unbindEvents();
      },
      bindEvents: function bindEvents() {
        if (!this.ignoreScrollLock) {
          slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }

        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);

          if (!doNotClose) {
            this.close();
            return false;
          }
        }.bind(this));
        this.$nodes.parent.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
      unbindEvents: function unbindEvents() {
        if (!this.ignoreScrollLock) {
          slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }

        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },
      elementInsideDrawer: function elementInsideDrawer($el) {
        return this.$drawer.find($el).length;
      }
    });
    return Drawer;
  }();

  theme.cart = {
    getCart: function getCart() {
      return $.getJSON('/cart.js');
    },
    changeItem: function changeItem(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
    addItemFromForm: function addItemFromForm(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function _updateCart(params) {
      return $.ajax(params).then(function (cart) {
        this._checkGwp_with_no_buy_multiple(cart);

        $("body").trigger('updatePromoCart');
        return cart;
      }.bind(this));
    },
    _updatePromoCart: function _updatePromoCart(params) {
      return $.ajax(params).then(function (cart) {
        return cart;
      }.bind(this));
    },
    _addGWPItem: function _addGWPItem(cart, getSelector, order) {
      free = getSelector.split(",");
      free_id = free[order];
      getfree = cart.items.filter(function (item, index) {
        return parseInt(free_id) == item.id;
      });

      if (!getfree.length && $('.free-item').length == 0) {
        //has multiple free items
        if (free.length > 1) {
          var items = [];
          $.each(free, function (index, key) {
            items.push({
              quantity: 1,
              id: key.trim()
            });
          });
          data = {
            items: items
          };
        } else {
          data = {
            quantity: 1,
            id: free_id
          };
        }

        params = {
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function success(cart) {
            console.log('count', cart);
            $('.cart-link__bubble').text(parseInt($('.cart-link__bubble').first().text()) + 1);
            $('body').trigger('added.ajaxProduct');
            $("#CartContainer").removeClass("is-loading");
          },
          error: function error(resp) {
            newOrder = order + 1;

            if (order < 4) {
              theme.cart._addGWPItem(cart, getSelector, newOrder);
            } else {
              $("#CartContainer").removeClass("is-loading");
            }

            $('body').trigger('added.ajaxProduct');
          }
        };
        $.ajax(params);
      }
    },
    _checkGwp_with_no_buy_multiple: function _checkGwp_with_no_buy_multiple(cart) {
      gCart = this.getCart();
      _this = this;
      gCart.done(function (cart) {
        console.log('cart', cart);
        autoGwp = 'false' === 'true';
        multiple_free_item = 'false' === 'true';
        _cart = cart;
        nofree = false;

        if (sessionStorage.getItem("nofreeid") == 'true') {
          nofree = true;
        }

        if (cart.total_price == 0 && cart.item_count > 0) {
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function success() {//smCart.buildCart(cart)
            },
            dataType: 'json'
          });
        }

        if (autoGwp && cart.items && !nofree) {
          buySelector = '28693010972747,29271204364363,28747900289099,28747900321867,28693054586955,29057865187403,29057762623563,29286895190091,28747678056523,28747678089291,29286497878091,28693054619723';
          getSelector = '32678422282315';
          minCart = parseInt('0');
          buySelectors = cart.items.filter(function (item, index) {
            return buySelector.indexOf(item.id) != -1;
          });
          getSelectors = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) != -1;
          });
          regularItems = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) == -1;
          });
          totalPrice = cart.original_total_price / 100;
          any_buy_selectors = 'false' === 'true';
          freeTotal = parseInt('0');

          if (buySelectors.length || any_buy_selectors || totalPrice == 0 || regularItems.length) {
            var noAdd = false;
            var noRemove = false;

            if (buySelectors.length && totalPrice > minCart && !getSelectors.length || any_buy_selectors && regularItems.length && totalPrice > minCart && !getSelectors.length) {
              theme.cart._addGWPItem(cart, getSelector, 0);
            } else {
              noAdd = true;
              noRemove = true;
            }

            if ('true' === 'true') {
              if (minCart > 0) {
                totalPrice = cart.original_total_price / 100 - freeTotal;
              }

              if (buySelectors.length == 0 && !any_buy_selectors || regularItems.length == 0 && any_buy_selectors || minCart && minCart > 0 && totalPrice < minCart || totalPrice == 0) {
                var key = getSelector;
                var qty = 0;
                free = getSelector.split(",");
                $.each(free, function (index, key) {
                  getfree = cart.items.filter(function (item, index) {
                    return parseInt(key) == item.id;
                  });
                  delay = 1000 * index;
                  index += 1;

                  if (getfree.length) {
                    $("#CartContainer").addClass("is-loading");
                    var items = {};
                    $.each(free, function (index, key) {
                      items[key] = qty;
                    });
                    data = {
                      updates: items
                    };
                    params = {
                      type: 'POST',
                      url: '/cart/update.js',
                      data: data,
                      dataType: 'json',
                      success: function success(cart) {
                        $('body').trigger('added.ajaxProduct');
                        $("#CartContainer").removeClass("is-loading");
                      }
                    };
                    $.ajax(params);
                  }
                });
              } else {
                noRemove = true;
              }
            }

            if (noAdd && noRemove) {
              $('body').trigger('added.ajaxProduct');
              $("#CartContainer").removeClass("is-loading");
            }
          } else {
            $('body').trigger('added.ajaxProduct');
            $("#CartContainer").removeClass("is-loading");
          }
        } else {
          $('body').trigger('added.ajaxProduct');
          $("#CartContainer").removeClass("is-loading");
        }
      });
    },
    _checkCartBeforeCheckout: function _checkCartBeforeCheckout(cart) {
      gCart = this.getCart();
      _this = this;
      $('.free-item .js-qty__num').val(1);
      gCart.done(function (cart) {
        if (cart.total_price == 0 && cart.item_count > 0) {
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function success() {//smCart.buildCart(cart)
            },
            dataType: 'json'
          });
        }

        autoGwp = 'false' === 'true';
        multiple_free_item = 'false' === 'true';
        _cart = cart;
        nofree = false;

        if (sessionStorage.getItem("nofreeid") == 'true') {
          nofree = true;
        }

        if (autoGwp && cart.items && !nofree) {
          buySelector = '28693010972747,29271204364363,28747900289099,28747900321867,28693054586955,29057865187403,29057762623563,29286895190091,28747678056523,28747678089291,29286497878091,28693054619723';
          getSelector = '32678422282315';
          minCart = parseInt('0');
          buySelectors = cart.items.filter(function (item, index) {
            return buySelector.indexOf(item.id) != -1;
          });
          getSelectors = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) != -1;
          });
          regularItems = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) == -1;
          });
          splitted = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) != -1;
          });
          totalPrice = cart.original_total_price / 100;
          any_buy_selectors = 'false' === 'true';
          freeTotal = parseInt('0');

          if (buySelectors.length || any_buy_selectors) {
            if ('true' === 'true') {
              if (minCart > 0) {
                totalPrice = cart.original_total_price / 100 - freeTotal;
              }

              if (buySelectors.length == 0 && !any_buy_selectors || regularItems.length == 0 && any_buy_selectors || minCart && minCart > 0 && totalPrice < minCart || splitted.length > 1) {
                var key = getSelector;
                var qty = 0;
                free = getSelector.split(",");
                $.each(free, function (index, key) {
                  getfree = cart.items.filter(function (item, index) {
                    return parseInt(key) == item.id;
                  });
                  delay = 1000 * index;
                  index += 1;

                  if (getfree.length) {
                    $("#CartContainer").addClass("is-loading");
                    data = {
                      id: key,
                      quantity: qty
                    };

                    if (splitted.length > 1 && index == 0) {
                      data = {
                        id: getfree[index].key,
                        quantity: 1
                      };
                    }

                    params = {
                      type: 'POST',
                      url: '/cart/change.js',
                      data: data,
                      dataType: 'json',
                      success: function success(cart) {
                        $('body').trigger('added.ajaxProduct');
                        $("#CartContainer").removeClass("is-loading");
                      }
                    };
                    $.ajax(params);
                  }
                });
              }
            }
          } else {
            $("#CartContainer").removeClass("is-loading");
          }
        }
      });
    },
    _checkGwp_with_no_buy: function _checkGwp_with_no_buy(cart) {
      gCart = this.getCart();
      _this = this;
      gCart.done(function (cart) {
        console.log(cart);
        autoGwp = 'false' === 'true';
        _cart = cart;

        if (autoGwp && cart.items) {
          buySelector = '28693010972747,29271204364363,28747900289099,28747900321867,28693054586955,29057865187403,29057762623563,29286895190091,28747678056523,28747678089291,29286497878091,28693054619723';
          getSelector = '32678422282315';
          minCart = parseInt('0');
          buySelectors = cart.items.filter(function (item, index) {
            return buySelector.indexOf(item.id) != -1;
          });
          getSelectors = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) != -1;
          });
          regularItems = cart.items.filter(function (item, index) {
            return getSelector.indexOf(item.id) == -1;
          });
          totalPrice = cart.original_total_price / 100;
          any_buy_selectors = 'false' === 'true';
          freeTotal = parseInt('0');

          if (buySelectors.length || any_buy_selectors) {
            if (buySelectors.length && totalPrice > minCart && !getSelectors.length || any_buy_selectors && regularItems.length && totalPrice > minCart && !getSelectors.length) {
              free = getSelector.split(",");
              $.each(free, function (index, free_id) {
                getfree = cart.items.filter(function (item, index) {
                  return parseInt(free_id) == item.id;
                });
                delay = 1000 * index;
                index += 1;

                if (!getfree.length) {
                  $("#CartContainer").addClass("is-loading");
                  setTimeout(function () {
                    data = {
                      quantity: 1,
                      id: free_id
                    };
                    params = {
                      type: 'POST',
                      url: '/cart/add.js',
                      data: data,
                      dataType: 'json',
                      success: function success(cart) {
                        $('.cart-link__bubble').text(parseInt($('.cart-link__bubble').first().text()) + 1);

                        if (free.length == index) {
                          $('body').trigger('added.ajaxProduct');
                        }
                      },
                      error: function error(resp) {
                        if (resp.status == 422) {
                          $("#CartContainer").removeClass("is-loading");
                        }
                      }
                    };
                    $.ajax(params);
                  }, delay);
                }
              });
            }

            if ('true' === 'true') {
              if (minCart > 0) {
                totalPrice = cart.original_total_price / 100 - freeTotal;
              }

              if (buySelectors.length == 0 && !any_buy_selectors || regularItems.length == 0 && any_buy_selectors || minCart && minCart > 0 && totalPrice < minCart) {
                var key = getSelector;
                var qty = 0;
                free = getSelector.split(",");
                $.each(free, function (index, key) {
                  getfree = cart.items.filter(function (item, index) {
                    return parseInt(key) == item.id;
                  });
                  delay = 1000 * index;
                  index += 1;

                  if (getfree.length) {
                    $("#CartContainer").addClass("is-loading");
                    setTimeout(function () {
                      data = {
                        id: key,
                        quantity: qty
                      };
                      params = {
                        type: 'POST',
                        url: '/cart/change.js',
                        data: data,
                        dataType: 'json',
                        success: function success(cart) {
                          if (free.length == index) {
                            $('body').trigger('added.ajaxProduct');
                          }
                        }
                      };
                      $.ajax(params);
                    }, delay);
                  }
                });
              }
            }
          } else {}
        }
      });
    },
    updateNote: function updateNote(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function success(cart) {},
        error: function error(XMLHttpRequest, textStatus) {}
      };
      $.ajax(params);
    },
    attributeToString: function attributeToString(attribute) {
      if (typeof attribute !== 'string') {
        attribute += '';

        if (attribute === 'undefined') {
          attribute = '';
        }
      }

      return $.trim(attribute);
    }
  };
  $(function () {
    $('body').on('click', '.cart__checkout', function () {
      $(this).addClass('btn--loading');
    });
    $('body').on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
    $('body').on('click', '.cart__checkout--ajax', function (evt) {
      if ($('#CartAgree').is(':checked')) {} else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
    $('body').on('click', '.cart__checkout--page', function (evt) {
      if ($('#CartPageAgree').is(':checked')) {} else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });

  theme.QtySelector = function () {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$originalInput = $el.find('input[type="number"]');
      this.minValue = this.$originalInput.attr('min') || 1;
      var defaults = {
        namespace: null
      };
      this.options = $.extend(defaults, options);
      this.source = $('#JsQty').html();
      this.template = Handlebars.compile(this.source);
      var quantities = {
        current: this._getOriginalQty(),
        add: this._getOriginalQty() + 1,
        minus: this._getOriginalQty() - 1
      };
      this.data = {
        key: this._getProductKey(),
        itemQty: quantities.current,
        itemAdd: quantities.add,
        itemMinus: quantities.minus,
        inputName: this._getInputName(),
        inputId: this._getId()
      };
      this.$originalInput.after(this.template(this.data)).remove();
      this.$input = this.$wrapper.find(classes.input);
      this.$plus = this.$wrapper.find(classes.plus);
      this.$minus = this.$wrapper.find(classes.minus);
      this.initEventListeners();
    }

    ;
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      _getProductKey: function _getProductKey() {
        return this.$originalInput.data('id') || null;
      },
      _getOriginalQty: function _getOriginalQty() {
        return parseInt(this.$originalInput.val());
      },
      _getInputName: function _getInputName() {
        return this.$originalInput.attr('name');
      },
      _getId: function _getId() {
        return this.$originalInput.attr('id');
      },
      initEventListeners: function initEventListeners() {
        this.$plus.on('click', function () {
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
        this.$minus.on('click', function () {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
        this.$input.on('change', function () {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
      addQty: function addQty(number) {
        var qty = number + 1;
        this.changeQty(qty);
      },
      subtractQty: function subtractQty(number) {
        var qty = number - 1;

        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.changeQty(qty);
      },
      changeQty: function changeQty(qty) {
        $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
      },
      validateQty: function validateQty(number) {
        if (parseFloat(number) == parseInt(number) && !isNaN(number)) {} else {
          number = 1;
        }

        return parseInt(number);
      }
    });
    return QtySelector;
  }();

  theme.CartDiscount = function () {
    var dataJson = {};
    var checkout_url = "";
    var discountCode = "";
    var processing = false;
    var refreshing = false;

    function CartDiscount() {
      if (sessionStorage.getItem('checkoutData')) {
        dataJson = JSON.parse(sessionStorage.getItem('checkoutData'));
      }

      _this = this;
    }

    CartDiscount.prototype = $.extend({}, CartDrawer.prototype, {
      checkoutData: function checkoutData() {
        return dataJson;
      },
      refreshData: function refreshData(cart) {
        if (!window.cart_promo_code) {
          return;
        }

        if (dataJson.applying_discount && cart.items.length && !refreshing) {
          url = Shopify.theme.role == 'main' ? dataJson.checkout_url + "?discount=" + dataJson.applying_discount : '/checkout?discount=' + dataJson.applying_discount;
          $.ajax({
            url: url,
            beforeSend: function beforeSend() {
              refreshing = true;
            },
            success: function success(result, status, xhr) {
              checkout_url = xhr.getResponseHeader('content-location');

              if (Shopify.theme.role == 'unpublished') {
                $.ajax({
                  url: checkout_url,
                  success: function success(result, status, xhr) {
                    _this.collectData(result, checkout_url);
                  }
                });
              } else {
                html = $(result);
                form = $(html).find("form.edit_checkout").attr("action");

                _this.collectData(result, form);
              }
            },
            complete: function complete(re) {
              refreshing = false;
            }
          });
        }
      },
      collectData: function collectData(result, checkoutUrl) {
        _this = this;
        html = $(result);
        d = $(html).filter("div#discount_application");
        errorMessage = $(html).find("form.edit_checkout").find("#error-for-reduction_code").text();
        dataJson = JSON.parse(d.html());
        dataJson.checkout_url = checkoutUrl.split("?")[0];
        dataJson.applying_discount = discountCode;
        dataJson.errorMessage = errorMessage;

        if (JSON.stringify(dataJson) != sessionStorage.getItem("checkoutData")) {
          sessionStorage.setItem("checkoutData", JSON.stringify(dataJson));
          new theme.CartDrawer();
        }
      },
      initEventListeners: function initEventListeners() {
        if (!window.cart_promo_code) {
          return;
        }

        _this = this;
        $(".promo_check").css({
          cursor: 'pointer'
        }).click(function () {
          $(this).hide();
          $(this).next().show();
        });
        $(".promo_input.input-discount").on('keydown', function (e, i) {
          if (e.keyCode == 13) {
            $(".submit__code .promo_apply").click();
            e.preventDefault();
          }
        });
        $(".submit__code .promo_apply").click(function () {
          txt = $(this).text();

          if (txt == 'Applied' || txt == 'Applying' || processing) {
            return;
          }

          promoCode = $(".promo_input.input-discount").val();

          if (promoCode.length > 2) {
            $(this).text('Applying');
            processing = true;
            $(".promo_input.input-discount").html();
            $(".promo_erros").html('').hide();
            discountCode = promoCode;

            _this.checkDiscount();
          }
        });
        $(".promo_close").click(function () {
          //$(".submit__code .promo_apply").text('Removing');
          if (sessionStorage.getItem('checkoutData')) {
            data = JSON.parse(sessionStorage.getItem('checkoutData'));

            _this.removeCodeCheckout(data.checkout_url);
          } else {
            $(".promo_input.input-discount").html();
            $(".promo_erros").html('').hide();
          }

          sessionStorage.removeItem("checkoutData");
          dataJson = {};
          new theme.CartDrawer();
        });

        if (dataJson.applying_discount) {
          $(".promo_check").click();
        }
      },
      checkDiscount: function checkDiscount() {
        _this = this;
        $.ajax({
          url: "/checkout?discount=" + discountCode,
          beforeSend: function beforeSend() {
            $(".promo_erros").html('').hide();
          },
          success: function success(result, status, xhr) {
            checkout_url = xhr.getResponseHeader('content-location');

            if (Shopify.theme.role == 'unpublished') {
              $.ajax({
                url: checkout_url,
                success: function success(result, status, xhr) {
                  _this.extractData(result, checkout_url);
                }
              });
            } else {
              html = $(result);
              form = $(html).find("form.edit_checkout").attr("action");

              if (form) {
                _this.extractData(result, form);
              } else {
                $(".submit__code .promo_apply").text('Apply');
                $(".promo_erros").text('Ups, something went wrong. please try again');
                $(".promo_erros").show();
                processing = false;
              }
            }
          }
        });
      },
      extractData: function extractData(result, checkoutUrl) {
        _this = this;
        html = $(result);
        d = $(html).filter("div#discount_application");
        errorMessage = $(html).find("form.edit_checkout").find("#error-for-reduction_code").text();
        dataJson = JSON.parse(d.html());
        dataJson.checkout_url = checkoutUrl.split("?")[0];
        dataJson.applying_discount = discountCode;
        dataJson.errorMessage = errorMessage;
        discount = dataJson.discount_applications.filter(function (obj, index) {
          return obj.title.toLowerCase() == discountCode.toLowerCase() && obj.total_allocated_amount > 0;
        });

        if (discount.length) {
          applied = true;
          sessionStorage.setItem("checkoutData", JSON.stringify(dataJson));
          $('body').trigger('added.ajaxProduct');
        } else {
          applied = false;
          $(".promo_erros").html(dataJson.errorMessage).show();
          uri = dataJson.checkout_url;
          setTimeout(function () {
            _this.removeCodeCheckout(uri);
          }, 2000);
          sessionStorage.removeItem("checkoutData");
          dataJson = {};
          $(".submit__code .promo_apply").text('Apply');
        }

        processing = false;
      },
      removeCodeCheckout: function removeCodeCheckout(checkout_url) {
        $.ajax({
          url: checkout_url,
          data: "checkout[clear_discount]=1",
          type: "PATCH",
          complete: function complete() {}
        });
      }
    });
    return CartDiscount;
  }();

  theme.CartDrawer = function () {
    var config = {
      namespace: '.ajaxcart'
    };
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      fixedFooter: '.drawer__footer--fixed',
      fixedInnerContent: '.drawer__inner--has-fixed-footer',
      cartBubble: '.cart-link__bubble'
    };

    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
      this.qtySelectors = [];
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      this.cartDiscount = new theme.CartDiscount();
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
      theme.cart.getCart().then(this.buildCart.bind(this));
      this.initEventListeners();
    }

    ;
    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function initEventListeners() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
        $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));
        $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));
        $('body').on('added.ajaxProduct', function () {
          theme.cart.getCart().then(function (cart) {
            // theme.cart._checkGwp_with_no_buy_multiple(cart);
            _th = this;
            theme.cart.getCart().then(function (cart) {
              _th.buildCart(cart, true);
            });
          }.bind(this));
        }.bind(this));
        $('body').on('added.ajaxProductHp', function () {
          console.log();
          theme.cart.getCart().then(function (cart) {
            theme.cart._checkGwp_with_no_buy_multiple(cart);
          }.bind(this));
        });
      },
      buildCart: function buildCart(cart, openDrawer, updatePromo) {
        this.loading(true);
        this.emptyCart();
        _this = this;

        if (cart.item_count === 0) {
          sessionStorage.setItem('.gwp-' + 'MAMASDAY', false);
          sessionStorage.setItem('.gwp-' + 'MIRROR', false);

          var _cloned = $('.js-cart__upsell').clone();

          $(selectors.container).append(_cloned);

          var _targeted = $('#CartDrawer .js-cart__upsell');

          _cloned.find('.btn-upsell').insertAfter(_targeted);

          _cloned.fadeIn();

          removeCartRelative();
          cartDrawerCheckout();

          if (sessionStorage.getItem('checkoutData')) {
            data = JSON.parse(sessionStorage.getItem('checkoutData'));
            this.cartDiscount.removeCodeCheckout(data.checkout_url);
          } else {
            $(".promo_input.input-discount").html();
            $(".promo_erros").html('').hide();
          }

          sessionStorage.removeItem("checkoutData");
          this.cartDiscount.dataJson = {};
          this.cartDiscount.discountCode = "";
          $("#cartFormButtonSubmit").addClass("cart-empty");
        } else {
          $("#cartFormButtonSubmit").removeClass("cart-empty");
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
          var end_price = cart.total_price;
          var cartTotalSavings = 0;
          var discountCheck = false;
          discounts = _this.cartDiscount.checkoutData();
          console.log('dc', discounts);
          applied_code = false;
          disc_code = "";
          promo_code = {};
          discount_line_items = [];

          if (discounts.applying_discount) {
            applied_code = true;
            disc_code = discounts.applying_discount.toUpperCase();
            promo_code = discounts.discount_applications.filter(function (obj, index) {
              return obj.title.toUpperCase() == disc_code;
            });
            promo_code = promo_code[0];
            discount_line_items = discounts.line_items;
          }

          $.each(cart.items, function (index, product) {
            var prodImg;

            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }

            if (product.properties !== null) {
              $.each(product.properties, function (key, value) {
                if (key.charAt(0) === '_' || !value) {
                  delete product.properties[key];
                }
              });
            }

            animation_row += 2;
            var isFreeGift;

            if (product.properties != null && product.properties['Note'] == 'Free gift') {
              if (product.total_discount == 0) {
                end_price -= product.original_price;
              }

              isFreeGift = 'isGWPFreeGift' + ' custom_ajaxcart__' + product.id;
            } else {
              isFreeGift = 'custom_ajaxcart__' + product.id;
            }

            var compare_at_price;
            var compare_at_priceCustom;
            var original_priceCustom;
            $.ajax({
              url: '/products/' + product.handle + '.js',
              dataType: 'json',
              async: false,
              success: function success(data) {
                $.map(data.variants, function (variant) {
                  if (variant.id == product.variant_id) {
                    console.log('product =>', product);

                    if (product.discounted_price == 0) {
                      console.log('line 3');
                      compare_at_priceCustom = product.original_price * product.quantity;
                      original_priceCustom = 0;
                    } else {
                      console.log('line 3-1', variant.compare_at_price);

                      if (sessionStorage.getItem('checkoutData')) {
                        console.log('discount available');
                        compare_at_price = product.original_price * product.quantity;
                        compare_at_priceCustom = product.original_price * product.quantity;
                        original_priceCustom = product.original_price * product.quantity;
                      } else {
                        console.log('discount not available');
                        compare_at_price = variant.compare_at_price * product.quantity;
                        compare_at_priceCustom = variant.compare_at_price * product.quantity;
                        original_priceCustom = product.original_price * product.quantity;
                      }
                    }
                  }
                });
              }
            });
            var check_compare;

            if (compare_at_price == null) {
              check_compare = false;
            } else {
              check_compare = true;
            }

            saving = 0;

            if (product.final_price == 0) {
              saving = product.original_price;
            } else {
              if (compare_at_priceCustom) {
                saving = compare_at_priceCustom - original_priceCustom;
              } else {
                saving = 0;
              }
            }

            try {
              rstars = window.stars[product.product_id] ? window.stars[product.product_id] : "";
            } catch (e) {
              rstars = "";
            }

            var free_class = '';
            var isFreeItem = false;

            if (product.total_discount == product.original_price) {
              free_class = 'free-item';
              isFreeItem = true;
            }

            if (compare_at_price == 0) {
              check_compare = false;
            }

            item = {
              productid: product.product_id,
              key: product.key,
              stars: rstars,
              url: product.url,
              prodid: product.id,
              varid: product.variant_id,
              compare: theme.Currency.formatMoney(compare_at_price, theme.settings.moneywithFormat),
              img: prodImg,
              isFreeGift: isFreeGift,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              properties: product.properties,
              itemQty: product.quantity,
              final_price: product.final_price,
              price: theme.Currency.formatMoney(original_priceCustom, theme.settings.moneywithFormat),
              discountedPrice: theme.Currency.formatMoney(product.original_price - product.total_discount / product.quantity, theme.settings.moneyFormat),
              savingPercent: saving,
              discounts: product.discounts,
              discountsApplied: product.price === product.price - product.total_discount ? false : true,
              vendor: product.vendor,
              check_compare: check_compare,
              freeClass: free_class,
              isFreeItem: isFreeItem
            };

            if (promo_code.title && discount_line_items.length && promo_code.target_type == 'line_item' && promo_code.target_selection != "all") {
              discount_line = discount_line_items[index];

              if (discount_line) {
                if (parseInt(item.prodid) == parseInt(discount_line.variant_id)) {
                  if (discount_line.discount_allocations.length) {
                    apl = discount_line.discount_allocations.filter(function (obj, ind) {
                      return obj.discount_application.title.toUpperCase() == disc_code.toUpperCase();
                    });
                    apl = apl[0];

                    if (apl) {
                      console.log('apl =>', apl);
                      item.line_discount = apl.amount;
                      item.line_discount_code = apl.discount_application.title;
                      item.line_discount_format = theme.Currency.formatMoney(apl.amount, theme.settings.moneywithFormat);
                      item.final_price = discount_line.final_price * product.quantity;
                      item.price = theme.Currency.formatMoney(item.final_price, theme.settings.moneywithFormat);
                      item.savingPercent = compare_at_price - item.final_price;
                      console.log('saving', item.savingPercent);
                      end_price -= item.savingPercent;

                      if (compare_at_price == null) {
                        item.check_compare = true;
                        item.compare = theme.Currency.formatMoney(discount_line.original_price, theme.settings.moneywithFormat);
                      }
                    } else {
                      apl = discount_line.discount_allocations[0];

                      if (apl) {
                        item.line_discount = apl.amount;
                        item.line_discount_code = apl.discount_application.title;
                        item.line_discount_format = theme.Currency.formatMoney(apl.amount, theme.settings.moneywithFormat);
                      }
                    }
                  }
                } else {
                  discountCheck = true;
                }
              }
            }

            items.push(item);
          });
          $.map(items, function (item) {
            var cartTotalSaving = item.savingPercent;

            if (cartTotalSaving > 0) {
              cartTotalSavings += cartTotalSaving;
            }
          });
          applied_code_message = "";

          if (promo_code.title && promo_code.target_selection == 'all') {
            cartTotalSavings += promo_code.total_allocated_amount;
            end_price = end_price - promo_code.total_allocated_amount;
          }

          if (promo_code.title) {
            if (promo_code.value_type == 'percentage') {
              applied_code_message = "Here's " + promo_code.value + "% off for you BossBabe!";
            } else {
              applied_code_message = "Here's " + theme.Currency.formatMoney(promo_code.value, theme.settings.moneywithFormat) + " off for you BossBabe!";
            }
          }

          animation_row += 2;
          data = {
            applied_code: applied_code,
            discount_code: disc_code,
            applied_code_message: applied_code_message,
            currency: theme.Currency.formatMoney(end_price, theme.settings.moneyFormat).slice(-3),
            items: items,
            cartTotalSavings: theme.Currency.formatMoney(cartTotalSavings, theme.settings.moneywithFormat),
            note: cart.note,
            lastAnimationRow: animation_row,
            totalPrice: theme.Currency.formatMoney(end_price, theme.settings.moneywithFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)),
            show_promo_code: window.cart_promo_code
          };
          $(selectors.container).append(this.template(data));
          window.currentCart = cart;

          if (updatePromo == undefined && updatePromo != true) {
            $('body').trigger("updatedCartDrawer");
          }

          this.cartDiscount.initEventListeners();

          if (discountCheck) {
            this.cartDiscount.checkDiscount();
          }

          $("body").trigger("DrawerElementUpdated");
          addCartRelative();
        }

        if (window.discountAccordion && typeof disc_code != 'undefined' && disc_code != '') {
          $(document).find('#input_accordion .sign').text('-');
          $(document).find('#input_accordion .promo-content').addClass('has-code').css({
            'display': 'block'
          });
        }

        var code = sessionStorage.getItem('code');

        if (code) {
          fillInputDiscountField(code);
        }

        this.status.loaded = true;
        this.loading(false);

        if ($('body').hasClass('currencies-enabled')) {
          theme.currencySwitcher.ajaxrefresh();
        }

        $('body').trigger('updateCart' + config.namespace, cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
          setTimeout(function () {
            this.sizeFooter();
          }.bind(this), 800);
        }

        if (openDrawer === true) {
          this.drawer.open();
        }
      },
      initQtySelectors: function initQtySelectors() {
        this.qtySelectors = [];
        $(selectors.container).find('.js-qty').each(function (index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
          this.qtySelectors.push(selector);
        }.bind(this));
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },
      updateItem: function updateItem(evt, key, qty) {
        if (this.status.loading) {
          return;
        }

        this.loading(true);
        theme.cart.changeItem(key, qty).then(function (cart) {
          this.updateSuccess(cart);
        }.bind(this))["catch"](function (XMLHttpRequest) {
          this.updateError(XMLHttpRequest);
        }.bind(this)).always(function () {
          this.loading(false);
        }.bind(this));
      },
      loading: function loading(state) {
        this.status.loading = state;

        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
      emptyCart: function emptyCart() {
        $(selectors.container).empty();
      },
      updateSuccess: function updateSuccess(cart) {
        _this = this;
        $.getJSON("/cart.js", function (cart) {
          _this.buildCart(cart);
        });
      },
      updateError: function updateError(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
      sizeFooter: function sizeFooter() {
        if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
          return;
        }

        var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
        var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
        var cartFooterHeight = $cartFooter.outerHeight();
        $cartInner.css('bottom', cartFooterHeight);
        $cartFooter.css('height', cartFooterHeight);
      },
      updateCartNotification: function updateCartNotification(evt, cart) {
        if (cart.items.length >= 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
          $(selectors.cartBubble).text(cart.item_count);
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });
    return CartDrawer;
  }();

  theme.AjaxProduct = function () {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');

      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    }

    ;
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function addItemFromForm(evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        this.$addToCart.addClass('btn--loading');
        status.loading = true;
        var data = this.$form.serialize();
        theme.cart.addItemFromForm(data).then(function (product) {
          this.success(product);
        }.bind(this))["catch"](function (XMLHttpRequest) {
          this.error(XMLHttpRequest);
        }.bind(this)).always(function () {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
      },
      success: function success(product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct');
      },
      error: function error(XMLHttpRequest) {
        this.$form.find('.errors').remove();

        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          console.warn(XMLHttpRequest.responseJSON.description);
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
    return ProductForm;
  }();

  theme.collapsibles = function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
    var isTransitioning = false;

    function init() {
      $(selectors.trigger).each(function () {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
      $('body, .modal__inner').on('click', selectors.trigger, function () {
        if (isTransitioning) {
          return;
        }

        isTransitioning = true;
        var $el = $(this);
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);

        if (isOpen && isAutoHeight) {
          setTimeout(function () {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }

        if (isOpen && !isAutoHeight) {
          height = 0;
        }

        $el.attr('aria-expanded', !isOpen).toggleClass(classes.open, !isOpen);

        var _text = $el.find('span').text();

        if (_text == "+") {
          $el.find('span').text('-');
        } else {
          $el.find('span').text('+');
        }

        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }

    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module.removeClass(classes.hide).prepareTransition().css('height', height).toggleClass(classes.open, !isOpen);

      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function () {
          o.css('height', 'auto');
          isTransitioning = false;
        }, 350);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  }();

  theme.headerNav = function () {
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;

    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
      config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');

      if (config.stickyEnabled) {
        theme.config.stickyHeader = true;
        stickyHeader();
      }

      if (config.wrapperOverlayed) {
        $('body').addClass('overlaid-header');
      }

      accessibleDropdowns();
      searchDrawer();
    }

    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }

    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function (evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
      $(selectors.closeSearch).on('click' + config.namespace, function () {
        closeSearchDrawer();
      });
    }

    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open js-drawer-open--search');
      slate.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });

      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0, 0);
      }

      slate.a11y.lockMobileScrolling(config.namespace);
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
      $parent.on('keyup' + config.namespace, function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }

    function closeSearchDrawer() {
      $(document.activeElement).trigger('blur');
      $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
      slate.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
      slate.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function (evt) {
          var $el = $(this);
          var $parentItem = $el.parent();

          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function (evt) {
          var $el = $(this);
          var $parentItem = $el.parent();

          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            window.location.replace($el.attr('href'));
          }
        });
      }

      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function () {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown($(this));
      });
      $(selectors.navLinks).on('mouseleave' + config.namespace, function () {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function () {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openSecondLevelDropdown($(this), true);
      });

      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();

        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function () {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }

      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();

        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }

      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }

    function stickyHeader() {
      config.lastScroll = 0;
      $siteHeader.wrap('<div class="site-header-sticky"></div>');
      stickyHeaderHeight();
      setTimeout(function () {
        stickyHeaderHeight();
      }, 200);
      $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
      $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
    }

    function stickyHeaderHeight() {
      var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
    }

    function stickyHeaderScroll() {
      var scroll = $window.scrollTop();
      var threshold = 250;

      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;
        $siteHeader.addClass(config.stickyClass);

        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }

        setTimeout(function () {
          $siteHeader.addClass(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;
        $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);

        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }

      config.lastScroll = scroll;
    }

    return {
      init: init,
      unload: unload
    };
  }();

  theme.Slideshow = function () {
    this.$slideshow = null;
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };

    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };
      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init', this.init.bind(this));
      this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
      this.$slideshow.slick(this.settings);
      this.$pause.on('click', this._togglePause.bind(this));
    }

    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function init(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
        this.$slideshow.addClass(classes.init);

        this._a11y();

        this._clonedLazyloading();
      },
      beforeSlideChange: function beforeSlideChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function afterSlideChange(event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function destroy() {
        this.$slideshow.slick('unslick');
      },
      _play: function _play() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function _pause() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function _togglePause() {
        var slideshowSelector = this._getSlideshowId(this.$pause);

        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
      _getSlideshowId: function _getSlideshowId($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function _activeSlide() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function _currentSlide() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function _nextSlide(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
      _a11y: function _a11y() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;

        if (!$list) {
          return;
        }

        $list.removeAttr('aria-live');
        $(classes.wrapper).on('focusin', function (evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');

          if (autoplay) {
            this._pause();
          }
        }.bind(this));
        $(classes.wrapper).on('focusout', function (evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');

          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
      _clonedLazyloading: function _clonedLazyloading() {
        var $slideshow = this.$slideshow;
        $slideshow.find('.slick-slide').each(function (index, el) {
          var $slide = $(el);

          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
            setTimeout(function () {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
            }, this.settings.autoplaySpeed / 1.5);
          }
        }.bind(this));
      }
    });
    return slideshow;
  }();

  theme.announcementBar = function () {
    var slideCount = 0;
    var compact = false;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 20,
      slidesToShow: 1
    };
    var $slider;

    function init() {
      $slider = $('#AnnouncementSlider');

      if (!$slider.length) {
        return;
      }

      slideCount = $slider.data('block-count');
      compact = $slider.data('compact-style');
      var desktopOptions = $.extend({}, defaults, {
        slidesToShow: compact ? 1 : slideCount,
        slidesToScroll: 1
      });
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1
      });

      if (theme.config.bpSmall) {
        initSlider($slider, mobileOptions);
      } else {
        initSlider($slider, desktopOptions);
      }

      $('body').on('matchSmall', function () {
        initSlider($slider, mobileOptions);
      }.bind(this));
      $('body').on('matchLarge', function () {
        initSlider($slider, desktopOptions);
      }.bind(this));
    }

    function initSlider($slider, args) {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }

      $slider.slick(args);
    }

    function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }

    function onBlockSelect(id) {
      var $slide = $('#AnnouncementSlide-' + id);

      if ($slider.length) {
        $slider.slick('slickPause');
      }

      if ($slide.length) {
        $slider.slick('slickGoTo', $slide.data('index'));
      }
    }

    function onBlockDeselect(id) {
      if ($slider.length && isInitialized($slider)) {
        $slider.slick('slickPlay');
      }
    }

    function unload() {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  }();

  theme.currencySwitcher = function () {
    var selectors = {
      dataDiv: '#CurrencyData',
      picker: '.currency-input'
    };
    var data = {};

    function init() {
      var $dataDiv = $(selectors.dataDiv);

      if (!$dataDiv.length) {
        return;
      }

      $primaryPicker = $('#CurrencyPicker-header');
      $drawerPicker = $('#CurrencyPicker-drawer');
      $primaryPicker.on('change', function () {
        $drawerPicker.val($(this).val());
      });
      $drawerPicker.on('change', function () {
        $primaryPicker.val($(this).val());
      });
      data = {
        currency: $dataDiv.data('shop-currency'),
        "default": $dataDiv.data('default-currency'),
        format: $dataDiv.data('format'),
        moneyFormat: $dataDiv.data('money-format'),
        moneyCurrencyFormat: $dataDiv.data('money-currency-format')
      };
      Currency.format = data.format;
      Currency.money_format[data.currency] = data.moneyFormat;
      Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;
      $('span.money span.money').each(function () {
        $(this).parents('span.money').removeClass('money');
      });
      $('span.money').each(function () {
        $(this).attr('data-currency-' + data.currency, $(this).html());
      });
      checkCookie();
      $(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
    }

    function refresh() {
      var newCurrency = $(selectors.picker).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
    }

    function ajaxrefresh() {
      var newCurrency = $(selectors.picker).val();
      Currency.convertAll(data.currency, newCurrency);
    }

    function checkCookie() {
      var cookieCurrency = Currency.cookie.read();

      if (cookieCurrency == null) {
        if (data.currency !== data["default"]) {
          Currency.convertAll(data.currency, data["default"]);
        } else {
          Currency.currentCurrency = data["default"];
        }
      } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
        Currency.currentCurrency = data.currency;
        Currency.cookie.write(data.currency);
      } else if (cookieCurrency === data.currency) {
        Currency.currentCurrency = data.currency;
      } else {
        Currency.convertAll(data.currency, cookieCurrency);
      }
    }

    return {
      init: init,
      refresh: refresh,
      ajaxrefresh: ajaxrefresh
    };
  }();

  theme.initQuickShop = function (reinit) {
    var ids = [];
    var $buttons = $('.quick-product__btn');
    $buttons.each(function () {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;

      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="' + id + '"]').each(function (i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }

      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };

  theme.videoModal = function () {
    var videoModalPlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
    var selectors = {
      triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
    };

    if (!$(selectors.triggers).length) {
      return;
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
    $(selectors.triggers).on('click', triggerYouTubeModal);

    function triggerYouTubeModal(evt) {
      evt.preventDefault();
      window.loadYouTube();

      if (theme.config.youTubeReady) {
        startVideoOnClick(evt);
      } else {
        $('body').on('youTubeReady', function () {
          startVideoOnClick(evt);
        });
      }
    }

    function startVideoOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
      var videoModalPlayer = new YT.Player('VideoHolder', args);
      modal.open();
      $('body').on('modalClose.VideoModal', function () {
        setTimeout(function () {
          videoModalPlayer.destroy();
        }, 500);
      });
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }
  };

  theme.parallaxSections = {};

  theme.Parallax = function () {
    var speed = 7;

    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;

      if (!this.$container.length) {
        return;
      }

      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args);
      }
    }

    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function init(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
        $window.on('scroll' + this.namespace, function (evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
        $window.on('resize' + this.namespace, $.debounce(350, function () {
          $window.off(this.namespace);

          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }

          this.init();
        }.bind(this)));
      },
      desktopInit: function desktopInit() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }

        $('body').on('matchSmall', function () {
          this.destroy();
        }.bind(this));
        $('body').on('matchLarge', function () {
          this.init(true);
        }.bind(this));
      },
      destroy: function destroy() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
    return parallax;
  }();

  theme.collectionTemplate = function () {
    var isAnimating = false;
    var selectors = {
      collectionGrid: '.grid--collection',
      sidebar: '#CollectionSidebar',
      tags: '.tag-list a',
      removeTag: '.tag--remove a'
    };
    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };
    var classes = {
      activeTag: 'tag--active'
    };

    function init() {
      $(window).on('popstate', function (state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });
      initTagClicks();
    }

    function initTagClicks() {
      $('body').on('click', selectors.tags, function (evt) {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if ($(this).hasClass('no-ajax')) {
          return;
        }

        evt.preventDefault();

        if (isAnimating) {
          return;
        }

        isAnimating = true;
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');

        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }

        updateScroll(true);
        history.pushState({}, '', newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
      $('body').on('click', selectors.removeTag, function () {
        $(this).parent('li').remove();
      });
    }

    function updateScroll(animate) {
      var scrollTo;

      if (theme.config.bpSmall) {
        scrollTo = $('.collection-filter').offset().top - 10;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }

      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }

      if (animate) {
        $('html, body').animate({
          scrollTop: scrollTo
        }, 300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }

    function getNewCollectionContent(url) {
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function () {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));
    }

    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');
      updateScroll(false);
      initTagClicks();
      AOS.refreshHard();
      theme.pageTransitions();
      theme.initQuickShop(true);

      if ($('body').hasClass('currencies-enabled')) {
        theme.currencySwitcher.ajaxrefresh();
      }

      if (window.SPR) {
        SPR.initDomEls();
        SPR.loadBadges();
      }

      sections.register('product-template', theme.Product);
    }

    return {
      init: init,
      reinit: reinit
    };
  }();

  theme.customerTemplates = function () {
    function initEventListeners() {
      $('#RecoverPassword').on('click', function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
      $('#HideRecoverPasswordLink').on('click', function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }

    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');

      if (!$formState.length) {
        return;
      }

      $('#ResetSuccess').removeClass('hide');
    }

    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');

      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }

      if (Shopify) {
        $('.js-address-country').each(function () {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId
          });
        });
      }

      $('.address-new-toggle').on('click', function () {
        $newAddressForm.toggleClass('hide');
      });
      $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
      $('.address-delete').on('click', function () {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');

        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {
            parameters: {
              _method: 'delete'
            }
          });
        }
      });
    }

    function checkUrlHash() {
      var hash = window.location.hash;

      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    return {
      init: function init() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  }();

  theme.Product = function () {
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      zoomInit: 'photo-zoom-init'
    };
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      zoomImage: '.photo-zoom-link__initial'
    };
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target;
      var player = youtubePlayers[playerId];
      setParentAsLoading($player);

      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }

      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }

    function initCheckVisibility(playerId) {
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {
        id: playerId
      }, $.throttle(150, videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (typeof id === 'string') {
        playerId = id;
      } else {
        playerId = id.data.id;
      }

      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }

        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1:
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }

          break;

        case 0:
          player.playVideo();
          break;

        case 1:
          setParentAsLoaded($player);
          break;

        case 3:
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el.closest(selectors.videoParent).addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el.closest(selectors.videoParent).removeClass(classes.loading).addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el.closest(selectors.videoParent).addClass(classes.interactable);
    }

    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.inModal = $container.closest('.modal').length;
      this.$modal;
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        zoom: $container.data('image-zoom') || false,
        inventory: $container.data('inventory') || false,
        modalInit: false,
        lazyLoadModalContent: $container.data('lazyload-content') || false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x'
      };

      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }

      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        video: 'ProductVideo-' + sectionId,
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        productImageMain: '.product-image-main--' + sectionId,
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();

      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }

      this.init();
    }

    Product.prototype = $.extend({}, Product.prototype, {
      init: function init() {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }

        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
          this.checkIfVideos();
          this.createImageCarousels();
        }
      },
      formSetup: function formSetup() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
      productSetup: function productSetup() {
        this.setImageSizes();
        this.initImageSwitch();
      },
      stringOverrides: function stringOverrides() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
      setImageSizes: function setImageSizes() {
        if (!this.settings.hasImages) {
          return;
        }

        var currentImage = this.$firstProductImage[0].currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }

        if (this.settings.zoom) {
          this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
        }
      },
      initVariants: function initVariants() {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }

        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };

        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function (evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }

        this.variants = new slate.Variants(options);
        this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));

        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        if (this.settings.inventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
      },
      updateColorName: function updateColorName(color, index) {
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },
      updateCartButton: function updateCartButton(evt) {
        var variant = evt.variant;

        if (variant) {
          if (variant.available) {
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            $(this.selectors.addToCartText).html(theme.strings.addToCart);
          } else {
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
          }
        } else {
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
      updatePrice: function updatePrice(evt) {
        var variant = evt.variant;

        if (variant) {
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();

          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
            var savings = variant.compare_at_price - variant.price;
            $(this.selectors.savePrice).removeClass('hide').html(theme.strings.savePrice.replace('[saved_amount]', theme.Currency.formatMoney(savings, theme.settings.moneyFormat)));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
            $(this.selectors.savePrice).addClass('hide');
          }

          if ($('body').hasClass('currencies-enabled')) {
            theme.currencySwitcher.ajaxrefresh();
          }
        }
      },
      updateSku: function updateSku(evt) {
        var variant = evt.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          $(this.selectors.sku).html(newSku);
        }
      },
      updateInventory: function updateInventory(evt) {
        var variant = evt.variant;
        var showInventory = false;
        var quantity = 0;
        var $inventoryLabel = $(this.selectors.inventory);

        if (variant && variant.inventory_management === 'shopify') {
          showInventory = true;
          quantity = window.inventories[this.sectionId][variant.id];

          if (quantity === 0 || quantity > 10) {
            showInventory = false;
          }
        }

        if (!showInventory) {
          $inventoryLabel.addClass('hide');
        } else {
          $inventoryLabel.removeClass('hide').text(theme.strings.stockLabel.replace('[count]', quantity));
        }
      },
      updateVariantImage: function updateVariantImage(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
        var zoomSizedImgUrl;

        if (this.settings.zoom) {
          zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
        }

        var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');

        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

        if (typeof imageIndex === 'undefined') {
          return;
        }

        this.$mainSlider.slick('slickGoTo', imageIndex);
      },
      initImageSwitch: function initImageSwitch() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }

        var self = this;
        $(this.selectors.photoThumbs).on('click', function (evt) {
          evt.preventDefault();
        });
      },
      checkIfVideos: function checkIfVideos() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);

        if (!$productVideos.length) {
          return false;
        }

        var videoTypes = [];
        $productVideos.each(function () {
          var type = $(this).data('video-type');

          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });

        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            window.loadYouTube();
            $('body').on('youTubeReady' + this.settings.namespace, function () {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }

        if (videoTypes.indexOf('vimeo') > -1) {
          if (!vimeoReady) {
            window.loadVimeo();
            $('body').on('vimeoReady' + this.settings.namespace, function () {
              this.loadVimeoVideos($productVideos);
            }.bind(this));
          } else {
            this.loadVimeoVideos($productVideos);
          }
        }

        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }

        return videoTypes;
      },
      loadMp4Videos: function loadMp4Videos($videos) {
        $videos.each(function () {
          var $el = $(this);

          if ($el.data('video-type') != 'mp4') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');
          videos[this.id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
      loadVimeoVideos: function loadVimeoVideos($videos) {
        $videos.each(function () {
          var $el = $(this);

          if ($el.data('video-type') != 'vimeo') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('video-id');
          videos[this.id] = {
            type: 'vimeo',
            divId: id,
            id: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height')
          };
        });

        for (var key in videos) {
          if (videos[key].type != 'vimeo') {
            continue;
          }

          var args = $.extend({}, vimeoVideoOptions, videos[key]);
          vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
        }

        vimeoReady = true;
      },
      autoplayVimeoVideo: function autoplayVimeoVideo(id) {
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(id);
        } else {
          var $player = $('#' + id);
          setParentAsLoaded($player);
        }
      },
      requestToPlayVimeoVideo: function requestToPlayVimeoVideo(id) {
        var $player = $('#' + id);
        setParentAsLoading($player);

        if (!vimeoReady) {
          $('body').on('vimeoReady' + this.settings.namespace, function () {
            this.playVimeoVideo(id);
          }.bind(this));
          return;
        }

        this.playVimeoVideo(id);
      },
      playVimeoVideo: function playVimeoVideo(id) {
        vimeoPlayers[id].play();

        if (videos[id].style === 'muted') {
          vimeoPlayers[id].setVolume(0);
        }

        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
      stopVimeoVideo: function stopVimeoVideo(id) {
        if (!theme.config.vimeoReady) {
          return;
        }

        if (id) {
          vimeoPlayers[id].pause();
        } else {
          for (key in vimeoPlayers) {
            if (typeof vimeoPlayers[key].pause === 'function') {
              vimeoPlayers[key].pause();
            }
          }
        }
      },
      loadYoutubeVideos: function loadYoutubeVideos($videos) {
        $videos.each(function () {
          var $el = $(this);

          if ($el.data('video-type') != 'youtube') {
            return;
          }

          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
          videos[this.id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            width: $el.data('video-width'),
            height: $el.data('video-height'),
            attemptedToPlay: false
          };
        });

        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);

              if (args.style === 'muted') {} else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }

              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }

        youtubeReady = true;
      },
      requestToPlayYoutubeVideo: function requestToPlayYoutubeVideo(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }

        var $player = $('#' + id);
        setParentAsLoading($player);

        if (typeof youtubePlayers[id].playVideo != 'function') {
          var o = this;
          setTimeout(function () {
            o.playYoutubeVideo(id, forcePlay);
          }, 1000);
          return;
        }

        this.playYoutubeVideo(id, forcePlay);
      },
      playYoutubeVideo: function playYoutubeVideo(id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);

        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }

        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
      stopYoutubeVideo: function stopYoutubeVideo(id) {
        if (!theme.config.youTubeReady) {
          return;
        }

        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }

          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            if (typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
      playMp4Video: function playMp4Video(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        $player[0].play();
      },
      stopMp4Video: function stopMp4Video(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          for (var key in videos) {
            if (videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];

              if (typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
      initZoom: function initZoom($image) {
        var largeImage = $image.parent().data('zoom-size');
        $image.parent().on('click', function (evt) {
          evt.preventDefault();
        }).zoom({
          on: 'click',
          url: largeImage,
          duration: 180,
          touch: false,
          onZoomIn: function onZoomIn() {
            $(this).addClass('photo-zoom-linked');
          },
          onZoomOut: function onZoomOut() {
            $(this).removeClass('photo-zoom-linked');
          }
        });
      },
      createImageCarousels: function createImageCarousels() {
        if (this.settings.zoom) {
          this.initZoom($(this.selectors.productImageMain).find(selectors.zoomImage));
        }

        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);

          if ($video.length) {
            this.initVideo($video);
          }

          return;
        }

        this.settings.hasMultipleImages = true;
        var $activeSlide = this.$mainSlider.find('.starting-slide');

        var startIndex = this._slideIndex($activeSlide);

        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.mainSliderArgs = {
          infinite: true,
          arrows: true,
          variableWidth: false,
          dots: false,
          adaptiveHeight: true,
          initialSlide: startIndex
        };
        this.thumbSliderArgs = {
          initialSlide: startIndex
        };

        if (AOS) {
          AOS.refresh();
        }
      },
      initSliders: function initSliders(args) {
        this.destroyImageCarousels();
        this.$mainSlider.slick(args.main);

        if (!theme.config.bpSmall) {
          this.$thumbSlider.slick(args.thumbs);
          this.settings.slickThumbInitialized = true;
        }

        this.settings.slickMainInitialized = true;
      },
      setSliderArgs: function setSliderArgs() {
        var args = {};
        var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: false,
            accessibility: false,
            arrow: true,
            dots: false,
            infinite: true,
            fade: true,
            autoplay: false,
            autoplaySpeed: 4000
          });
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            dots: false,
            focusOnSelect: true,
            infinite: true
          });
        }

        productPhotoSelector = this.selectors.mainSlider;
        return args;
      },
      destroyImageCarousels: function destroyImageCarousels() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }

        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
      },
      mainSlideInit: function mainSlideInit(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);

        if (!$video.length) {
          return;
        }

        this.initVideo($video);
      },
      initVideo: function initVideo($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');

        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }

        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }

        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function () {
              this.playOrShowVimeo(divId);
            }.bind(this));
          }
        }

        if (this.inModal) {
          this.resizeSlides();
        }
      },
      playOrShowVimeo: function playOrShowVimeo(id) {
        if (videos[id] && videos[id].style === 'muted') {
          this.autoplayVimeoVideo(id);
        } else if (videos[id] && videos[id].style === 'unmuted') {
          setParentAsLoaded($('#' + id));
        }
      },
      getVideoType: function getVideoType($video) {
        return $video.data('video-type');
      },
      getVideoId: function getVideoId($video) {
        return $video.attr('id');
      },
      beforeSlideChange: function beforeSlideChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');

        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);

          if (prevVideoId) {
            if (prevVideoType === 'youtube') {
              this.stopYoutubeVideo(prevVideoId);
            }

            if (prevVideoType === 'mp4') {
              this.stopMp4Video(prevVideoId);
            }

            if (prevVideoType === 'vimeo') {
              this.stopVimeoVideo(prevVideoId);
            }
          }
        }

        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);

          if (nextVideoId && nextVideoType === 'vimeo') {
            if (vimeoReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            } else {
              $('body').on('vimeoReady' + this.settings.namespace, function () {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.autoplayVimeoVideo(nextVideoId);
                }
              }.bind(this));
            }
          }

          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function () {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this));
            }
          }

          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }

          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }

        if (this.settings.zoom) {
          if ($nextSlide.hasClass(classes.zoomInit)) {
            return;
          }

          var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
          this.initZoom($image);
        }
      },
      resizeSlides: function resizeSlides() {
        if (!this.settings.hasMultipleImages) {
          return;
        }

        $(window).trigger('resize');
        setTimeout(function () {
          this.$mainSlider.slick('setPosition');
          this.$thumbSlider.slick('setPosition');
        }.bind(this), 500);
      },
      _slideIndex: function _slideIndex($el) {
        return $el.data('index');
      },
      initQtySelector: function initQtySelector() {
        this.$container.find('.js-qty').each(function () {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
      initAjaxProductForm: function initAjaxProductForm() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
      openModalProduct: function openModalProduct() {
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function () {
            $formHolder.addClass('is-active');
            this.formSetup();

            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));
          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.settings.modalInit = true;
        }

        this.resizeSlides();
      },
      closeModalProduct: function closeModalProduct() {
        this.stopYoutubeVideo();
        this.stopVimeoVideo();
        this.stopMp4Video();
      },
      loadModalContent: function loadModalContent() {
        var videoTypes = this.checkIfVideos();

        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal.find('.product__video[data-video-type="mp4"]').each(function (i, video) {
            var $el = $(video);
            var src = $el.data('video-src');
            var source = document.createElement('source');
            source.setAttribute('src', src);
            $el.append(source);
          }.bind(this));
        }
      },
      onUnload: function onUnload() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
      }
    });
    return Product;
  }();

  theme.CollectionHeader = function () {
    var selectors = {
      hero: '.collection-hero',
      parallaxContainer: '.parallax-container'
    };

    function CollectionHeader(container) {
      var $container = $(container);
      this.namespace = '.collection-header';
      var $heroImageContainer = $container.find(selectors.hero);

      if ($heroImageContainer.length) {
        if ($container.data('parallax')) {
          var $parallaxContainer = $container.find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      }
    }

    CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
      onUnload: function onUnload() {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
    return CollectionHeader;
  }();

  theme.CollectionSidebar = function () {
    var drawerStyle = false;

    function CollectionSidebar(container) {
      this.$container = $(container);
      this.init();
    }

    CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
      init: function init() {
        this.onUnload();
        drawerStyle = this.$container.data('style') === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
      forceReload: function forceReload() {
        this.init();
      },
      onSelect: function onSelect() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
      onDeselect: function onDeselect() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
      onUnload: function onUnload() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
    return CollectionSidebar;
  }();

  theme.Collection = function () {
    var selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image'
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.init();
    }

    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function init() {
        this.$container = $(this.container);
        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        this.namespace = '.collection-' + sectionId;
        this.sortBy();
        this.colorSwatchHovering();
        theme.reinitSection('collection-sidebar');
      },
      sortBy: function sortBy() {
        var $sortBy = $('#SortBy');

        if (!$sortBy.length) {
          return;
        }

        $sortBy.on('change' + this.namespace, function () {
          location.href = '?sort_by=' + $(this).val();
        });
      },
      colorSwatchHovering: function colorSwatchHovering() {
        var $colorImage = $(selectors.colorSwatchImage);

        if (!$colorImage.length) {
          return;
        }

        var $swatches = this.$container.find(selectors.colorSwatch);
        $swatches.on({
          mouseenter: function mouseenter(evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            var image = $el.data('variant-image');
            $('.grid-product__color-image--' + id).css('background-image', 'url(' + image + ')').addClass('is-active');
          },
          mouseleave: function mouseleave(evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            $('.grid-product__color-image--' + id).removeClass('is-active');
          }
        });
      },
      forceReload: function forceReload() {
        this.onUnload();
        this.init();
      },
      onUnload: function onUnload() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
        $(selectors.colorSwatch).off(this.namespace);
      }
    });
    return Collection;
  }();

  theme.HeaderSection = function () {
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist'
    };
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };

    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      theme.reinitSection('slideshow-section');
      theme.currencySwitcher.init();
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();

      if (Shopify.designMode) {
        setTimeout(function () {
          $('body').trigger('resize');
        }, 500);
      }
    }

    Header.prototype = $.extend({}, Header.prototype, {
      initDrawers: function initDrawers() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }

        this.drawerMenuButtons();
      },
      drawerMenuButtons: function drawerMenuButtons() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function (evt) {
          evt.preventDefault();
          theme.NavDrawer.close();
        });
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
        $mobileSubNavToggle.on('click', function () {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;

          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }

          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
      onBlockSelect: function onBlockSelect(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
      onDeselect: function onDeselect() {
        theme.announcementBar.onBlockDeselect();
      },
      onUnload: function onUnload() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
      }
    });
    return Header;
  }();

  theme.FeaturedContentSection = function () {
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }

    return FeaturedContent;
  }();

  theme.slideshows = {};

  theme.SlideshowSection = function () {
    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
      var $imageContainer = $(container).find('.hero');

      if ($imageContainer.length) {
        $imageContainer.removeClass('loading loading--delayed').addClass('loaded');
      }

      this.init();

      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }

    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function init() {
        this.onUnload();
        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500
        };
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
      forceReload: function forceReload() {
        this.init();
      },
      onUnload: function onUnload() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }

        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
      onSelect: function onSelect() {
        $(this.slideshow).slick('slickPause');
      },
      onDeselect: function onDeselect() {
        $(this.slideshow).slick('slickPlay');
      },
      onBlockSelect: function onBlockSelect(evt) {
        var $slideshow = $(this.slideshow);
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
      onBlockDeselect: function onBlockDeselect() {
        $(this.slideshow).slick('slickPlay');
      }
    });
    return SlideshowSection;
  }();

  theme.VideoSection = function () {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
    var selectors = {
      videoParent: '.video-parent-section'
    };
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };

    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
      this.vimeoPlayer = [];

      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }

      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }

      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
        startMp4Playback(mp4Video).then(function () {})["catch"](function (error) {
          setVideoToBeInteractedWith($mp4Div);
        });
      }
    }

    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }

    function onVideoPlayerReady(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target;
      var player = youtubePlayers[playerId];
      setParentAsLoading($player);
      youtubePlayers[playerId].mute();
      $player.attr('tabindex', '-1');
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {
        id: playerId
      }, $.throttle(150, videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;

      if (typeof id === 'string') {
        playerId = id;
      } else {
        playerId = id.data ? id.data.id : false;
      }

      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt) {
      var $player = $(evt.target.a);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];

      switch (evt.data) {
        case -1:
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }

          break;

        case 0:
          player.playVideo();
          break;

        case 1:
          setParentAsLoaded($player);
          break;

        case 3:
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el.closest(selectors.videoParent).addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el.closest(selectors.videoParent).removeClass(classes.loading).addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el.closest(selectors.videoParent).addClass(classes.interactable);
    }

    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function initYoutubeVideo() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false
        };

        if (!youtubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
      loadYoutubeVideo: function loadYoutubeVideo() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
        youtubeReady = true;
      },
      initVimeoVideo: function initVimeoVideo() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
        this.$vimeoTrigger.on('click', +this.namespace, function (evt) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));

        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
      loadVimeoVideo: function loadVimeoVideo() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
        vimeoReady = true;

        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
      requestToPlayVimeoVideo: function requestToPlayVimeoVideo(id) {
        if (!vimeoReady) {
          $('body').on('vimeoReady' + this.namespace, function () {
            this.playVimeoVideo(id);
          }.bind(this));
          return;
        }

        this.playVimeoVideo(id);
      },
      playVimeoVideo: function playVimeoVideo(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
      onUnload: function onUnload(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
    return videoSection;
  }();

  theme.BackgroundImage = function () {
    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;

      if (!$container.length) {
        return;
      }

      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }

    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function onUnload(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
    return backgroundImage;
  }();

  theme.Instagram = function () {
    var isInit = false;

    function Instagram(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.instagram-' + sectionId;
      this.$target = $('#Instafeed-' + sectionId);

      if (!this.$target.length) {
        return;
      }

      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }

    Instagram.prototype = $.extend({}, Instagram.prototype, {
      checkVisibility: function checkVisibility() {
        if (isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }

        if (theme.isElementVisible(this.$container)) {
          this.init();
        }
      },
      init: function init() {
        isInit = true;
        var userId = this.$target.data('user-id');
        var clientId = this.$target.data('client-id');
        var count = parseInt(this.$target.data('count'));
        var gridItemWidth = this.$target.data('grid-item-width');
        var feed = this.feed = new Instafeed({
          target: this.$target[0],
          accessToken: clientId,
          get: 'user',
          userId: userId,
          limit: count + 2,
          template: '<div class="grid__item ' + gridItemWidth + '"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
          resolution: 'standard_resolution'
        });
        feed.run();
      }
    });
    return Instagram;
  }();

  theme.FadingImages = function () {
    var classes = {
      activeImage: 'active-image',
      finishedImage: 'finished-image',
      activeTitles: 'active-titles',
      finishedTitles: 'finished-titles',
      compensation: 'compensation'
    };

    function FadingImages(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var namespace = this.namespace = '.fading-images-' + sectionId;

      if (!$container.length) {
        return;
      }

      var $imageContainer = $container.find('.fading-images');
      theme.loadImageSection($imageContainer);
      this.data = {
        isInit: false,
        interval: $container.data('interval'),
        block_count: $container.data('count'),
        finish_interval: 1000,
        timer_offset: 400,
        active_image: 1,
        active_title: 1,
        removed_compensation: false
      };
      this.selectors = {
        $allTitles: $container.find('.fading-images-overlay__titles')
      };
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
    }

    FadingImages.prototype = $.extend({}, FadingImages.prototype, {
      checkVisibility: function checkVisibility() {
        if (this.data.isInit) {
          $(window).off('scroll' + this.namespace);
          return;
        }

        if (theme.isElementVisible(this.$container)) {
          this.startImages();
          this.startTitles();
          this.data.isInit = true;
        }
      },
      nextImage: function nextImage() {
        var $container = this.$container;

        if (!this.data.removed_compensation) {
          $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
          this.data.removed_compensation = true;
        }

        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.activeImage).addClass(classes.finishedImage);
        var target_image = this.data.active_image;
        window.setTimeout(function () {
          $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
        }, this.data.finish_interval);
        this.data.active_image++;

        if (this.data.active_image > this.data.block_count) {
          this.data.active_image = 1;
        }

        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
      },
      nextTitle: function nextTitle() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
        this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);
        this.data.active_title++;

        if (this.data.active_title > this.data.block_count) {
          this.data.active_title = 1;
        }

        var target_title = this.data.active_title;
        window.setTimeout(function () {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
        }, this.data.finish_interval - 200);
      },
      startImages: function startImages() {
        this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);
        var o = this;
        window.setTimeout(function () {
          var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
        }, this.data.timer_offset);
      },
      startTitles: function startTitles() {
        var $container = this.$container;
        var $allTitles = this.selectors.$allTitles;
        var target_title = this.data.active_title;
        window.setTimeout(function () {
          var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
          var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
          $container.find('.fading-images-overlay__title--1').text(newText1);
          $container.find('.fading-images-overlay__title--2').text(newText2);
          $allTitles.addClass(classes.activeTitles);
        }, 750);
        var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
      },
      onUnload: function onUnload() {
        $(window).off('scroll' + this.namespace);
      }
    });
    return FadingImages;
  }();

  theme.Blog = function () {
    function Blog(container) {
      this.tagFilters();
    }

    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function tagFilters() {
        var $filterBy = $('#BlogTagFilter');

        if (!$filterBy.length) {
          return;
        }

        $filterBy.on('change', function () {
          location.href = $(this).val();
        });
      },
      onUnload: function onUnload() {}
    });
    return Blog;
  }();

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    mediaQuerySmall: 'screen and (max-width: 767px)',
    mediaQueryMediumUp: 'screen and (min-width: 768px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: 'ontouchstart' in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
    stickyHeader: false,
    recentlyViewed: []
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {},
    productInfo: {}
  };

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  };

  window.loadYouTube = function () {
    if (theme.config.youtubeReady) {
      return;
    }

    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  window.loadVimeo = function () {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      checkIfVimeoIsReady().then(function () {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        $('body').trigger('vimeoReady');
      }).fail(function () {});
    }
  };

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;
    wait = setInterval(function () {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);
    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000);
    return deferred;
  }

  theme.checkPromotionBeforeCheckout = function () {
    if (window.promotionProduct) {
      var updatingCart = function updatingCart(params, index, length) {
        theme.cart._updatePromoCart({
          type: 'POST',
          url: '/cart/add.js',
          data: params,
          dataType: 'json'
        }).done(function (resp) {
          if (index == length - 1) {
            $("#cartFormButtonSubmitInput").click();
          }
        });
      };

      var onlyUnique = function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      };

      theme.cart.getCart().done(function (cart) {
        if (window.promotionProduct) {
          promoData = window.promotionsData;
          selectors = [];
          $.each(cart.items, function (index, item) {
            selectors.push(promoData.filter(function (it, index) {
              return it["buy"].indexOf(item.id) != -1;
            }));
          });
          selectors = selectors.reduce(function (acc, val) {
            if (acc == undefined) {
              acc = [];
            }

            return acc.concat(val);
          }, []);
          getSelectors = selectors.map(function (item, index) {
            return item["get"];
          });
          getSelectors = getSelectors.filter(onlyUnique);
          dataMiss = [];
          itemsIds = cart.items.map(function (itm, idx) {
            return itm.id;
          });
          $.each(getSelectors, function (index, id) {
            if (itemsIds.indexOf(parseInt(id)) == -1) {
              dataMiss.push({
                id: id,
                qty: 1,
                properties: {
                  "_promotion": true
                }
              });
            }
          });

          if (dataMiss.length) {
            $.each(dataMiss, function (index, params) {
              setTimeout(function () {
                updatingCart(params, index, dataMiss.length);
              }, 500);
            });
          } else {
            $("#cartFormButtonSubmitInput").click();
          }
        }
      });
    } else {
      $("#cartFormButtonSubmitInput").click();
    }
  };

  theme.promotion = function () {
    $("body").on("updatePromoCart", function (evt) {
      theme.cart.getCart().done(function (cart) {
        if (window.promotionProduct) {
          promoData = window.promotionsData;
          selectors = [];
          $.each(cart.items, function (index, item) {
            selectors.push(promoData.filter(function (it, index) {
              return it["buy"].indexOf(item.id) != -1;
            }));
          });
          selectors = selectors.reduce(function (acc, val) {
            if (acc == undefined) {
              acc = [];
            }

            return acc.concat(val);
          }, []);
          getSelectors = selectors.map(function (item, index) {
            return item["get"];
          });
          getSelectors = getSelectors.filter(onlyUnique);
          dataMiss = [];
          itemsIds = cart.items.map(function (itm, idx) {
            return itm.id;
          });
          $.each(getSelectors, function (index, id) {
            if (itemsIds.indexOf(parseInt(id)) == -1) {
              dataMiss.push({
                id: id,
                qty: 1,
                properties: {
                  "_promotion": true
                }
              });
            }
          });
          $.each(dataMiss, function (index, params) {
            setTimeout(function () {
              updatingCart(params, index, dataMiss.length);
            }, 500);
          });
        }
      });
    });

    function updatingDrawer(dataMiss) {
      if (dataMiss > 0) {
        $('body').trigger('added.ajaxProduct');
      }
    }

    function updatingCart(params, index, length) {
      theme.cart._updatePromoCart({
        type: 'POST',
        url: '/cart/add.js',
        data: params,
        dataType: 'json'
      }).done(function (resp) {
        if (index == length - 1) {
          updatingDrawer(length);
        }
      });
    }

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  };

  theme.init = function () {
    theme.setGlobals();
    theme.pageTransitions();
    theme.collectionTemplate.init();
    theme.initQuickShop();
    theme.videoModal();
    theme.customerTemplates.init();
    theme.collapsibles.init();
    theme.promotion();
    slate.rte.wrapTable();
    slate.rte.wrapVideo();
    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 30,
      disableMutationObserver: true
    });
    setTimeout(function () {
      AOS.refresh();
    }, 1000);
    $(document.documentElement).on('keyup.tab', function (evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });
    $('.footer__newsletter-input').on('keyup', function () {
      $(this).addClass('footer__newsletter-input--active');
    });

    if (window.promotionProduct) {
      $('body').trigger('updatePromoCart');
    }
  };

  theme.setGlobals = function () {
    theme.config.hasSessionStorage = theme.isSessionStorageSupported();

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function match() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function unmatch() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });
    enquire.register(theme.config.mediaQueryMediumUp, {
      match: function match() {
        $('body').trigger('matchLarge');
      },
      unmatch: function unmatch() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function ($container) {
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    }

    ;

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  };

  theme.isSessionStorageSupported = function () {
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function ($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;
    return rect.bottom >= 0 && rect.right >= 0 && rect.top <= windowHeight + threshold && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
  };

  theme.pageTransitions = function () {
    if ($('body').data('transitions') == true) {
      var namespace = '.page-transition';

      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        $('a').off(namespace).on('click' + namespace, function () {
          window.setTimeout(function () {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
        $(this).addClass('js-no-transition');
      });
      $('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function (evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function () {
          location.href = src;
        }, 50);
      });
      $('a.mobile-nav__link').off(namespace).on('click' + namespace, function () {
        theme.NavDrawer.close();
      });
    }
  };

  theme.reinitSection = function (section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];

      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  };

  window.onpageshow = function (evt) {
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function () {
    theme.init();
    window.sections = new theme.Sections();
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('header-section', theme.HeaderSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('product', theme.Product);
    sections.register('product-template', theme.Product);
    sections.register('collection-header', theme.CollectionHeader);
    sections.register('collection-sidebar', theme.CollectionSidebar);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('instagram', theme.Instagram);
    sections.register('fading-images', theme.FadingImages);
    sections.register('blog', theme.Blog);
    setTimeout(function () {
      $("body").css("opacity", 1);
    }, 1000); // theme.instagramBrowserHandle_2();
  });

  theme.instagramBrowserHandle_2 = function () {
    console.log('ig2');

    if (!theme.isInstagramBrowser() || theme.isAndroid()) {
      return;
    }

    if (theme.isInstagramBrowser()) {
      var containerScroll = function containerScroll() {
        var htm = $(".instagram-browser-fixs").scrollTop();
        var htmp = $(".instagram-browser-fixs").parent().scrollTop();
        var body = $(".instagram-browser-fixs body").scrollTop();
        var isDrawerOpen = $('.instagram-browser-fixs').hasClass('js-drawer-open');

        if (htm > 0 && isDrawerOpen) {
          $(".instagram-browser-fixs").scrollTop(0);
        }

        vcs = document.documentElement.clientHeight;
        vis = window.innerHeight;
        vid = window.outerHeight;
        var isHide = false;

        if (vcs != vis) {
          $('html').removeClass('browser-hide-bar');
          isHide = false;
        } else {
          $('html').addClass('browser-hide-bar');
          isHide = true;
        }

        scrollt = '';

        if (htm > pos) {
          $('html').removeClass('browser-bar-up');
          scrollt = 'up';
        } else {
          $('html').addClass('browser-bar-up');
          scrollt = 'down';
        }

        pos = htm; // $("#debuger").text('html:'+htm +' body:'+body +'<br>'+ isHide + '__ '+ vcs+'-'+scrollt+'-'+vis);
      };

      $('html').addClass('instagram-browser-fixs'); // $("body").append("<span id='debuger' style='word-break:break-all;max-width:375px;top:50%;position:fixed;z-index:999999;padding:20px;background:#fff;'></span>")
      // $("#debuger").text(navigator.userAgent);

      $(window).scroll($.throttle(15, containerScroll));
      isHide = false;
      $('body').on('drawerOpen.CartDrawer', function () {
        $('html').removeClass('browser-hide-bar');
        $(".instagram-browser-fixs").scrollTop(-50);
      });
      var pos = $(".instagram-browser-fixs").scrollTop();
    }
  };

  theme.isInstagramBrowser = function () {
    agent = navigator.userAgent;
    return agent.toLowerCase().indexOf("instagram") != -1;
  };

  theme.isAndroid = function () {
    agent = navigator.userAgent;
    return agent.toLowerCase().indexOf("android") != -1;
  };

  theme.instagramBrowserHandle = function () {
    var runCheck;
    var diffHeight = window.innerHeight > 700 ? 60 : 44; //default

    if (!theme.isInstagramBrowser() || theme.isAndroid()) {
      return;
    }

    function checkAddressBar() {
      var vcs = document.documentElement.clientHeight;
      var vis = window.innerHeight;
      var vid = window.outerHeight;
      o = $("body").offset();
      c = $("#PageContainer").offset();

      if (vcs != vis) {
        $("html").removeClass("browser-hide-bar");
      } else {
        // $("#showBar").get(0).click();
        $("html").addClass("browser-hide-bar");
      }

      a = $("html").attr('class');
      c = document.body.offsetHeight;
      window.scrollTop = -100;
      document.body.scrollTop = -100;
      setTimeout(function () {
        window.scrollTop = 100;
        document.body.scrollTop = 100;
        window.scrollTop = -100;
        document.body.scrollTop = -100;
        diffHeight = window.screen.height > 700 ? 60 : 44; //default

        vcs = document.documentElement.clientHeight;
        vis = window.innerHeight;
        vid = window.outerHeight;

        if (vcs != vis) {
          $("html").removeClass("browser-hide-bar");
        } else {
          // $("#showBar").get(0).click();
          $("html").addClass("browser-hide-bar");
        }

        diff = diffHeight * 2;

        if ($("html").hasClass('browser-hide-bar')) {
          diff = diffHeight * 2 - 40;
        }

        c = $("body").offset().top;
        d = $("#PageContainer").offset().top;
        e = $("body").height();
        f = $("#PageContainer").height();

        if (!$(".popup-email--show").hasClass('onkeyboard')) {
          $(".popup-email--show").css("paddingBottom", diff);
        } // $("#bottomWrapper").css("bottom", diff);
        // $(".drawer--is-open .cart__checkout").css("bottom", diff + 10);

      }, 300);
    }

    $("body").append("<a href='#PageContainer' id='showBar' style='display:none;'>Show bar</a>");
    var timingTouchmove;
    document.addEventListener('touchmove', function (e) {
      mainScroll = $(e.target).parents("#PageContainer").attr("id");
      footerElement = $(e.target).parents("#shopify-section-footer").attr("id");
      headerElement = $(e.target).parents("#shopify-section-header").attr("id");
      drawerElement = $(e.target).parents(".drawer__inner").attr('class');
      tagName = e.target.tagName;

      if ($(".popup-email--show").hasClass('onkeyboard')) {
        e.preventDefault();
        return;
      }

      if (mainScroll == 'PageContainer' && headerElement == undefined && drawerElement == undefined && footerElement == undefined) {
        e.stopPropagation();
      } else if (mainScroll == 'PageContainer' && headerElement == 'shopify-section-header' && drawerElement != undefined) {
        e.stopPropagation();
      } else if (mainScroll == 'PageContainer' && footerElement == 'shopify-section-footer') {
        e.stopPropagation();
      } else if (tagName == 'HTML') {
        e.preventDefault();
      } else {
        e.preventDefault();
      }

      clearTimeout(timingTouchmove);
      timingTouchmove = setTimeout(function () {
        checkAddressBar();
      }, 500);
    }, {
      passive: false
    });

    if (theme.isInstagramBrowser()) {
      $("body,html").addClass("instagram-browser");
      $(".main-content").css('opacity', 0.9);
      var vc = document.documentElement.clientHeight;
      var vi = window.innerHeight;
      document.body.scrollTop = -100;
      window.scrollTop = -100;
      $(".popup-email--show").css("paddingBottom", diffHeight * 2);
      setTimeout(function () {// btn = $(".template-product .btn--full.add-to-cart");
        // if (btn) {
        //  newbtn = btn.clone();
        // newbtn.attr("id", "bottomWrapper");
        //btn.hide();
        // btn.attr("id", "originWrapperButton");
        // $('body').prepend(newbtn);
        // $("#bottomWrapper button").css("bottom", diffHeight * 2);
        // $("#bottomWrapper").click(function(){
        // $("#originWrapperButton").click();
        // })
        // checkAddressBar();
        // }
      }, 300);
      $("#emarsys-singup-popup").focus(function () {
        $(".popup-email--show").addClass('onkeyboard');
      }).focusout(function () {
        $(".popup-email--show").removeClass('onkeyboard');
        checkAddressBar();
      });
      $(".js-drawer-close").click(function () {
        setTimeout(function () {
          checkAddressBar();
        }, 200);
      });
      $("body").on("drawerOpen.CartDrawer", function () {
        checkAddressBar();
      });
      $("body").on("drawerOpen.NavDrawer", function () {
        checkAddressBar();
      });
    }

    var lastScroll = 0;
    var sectionLoad = false;
    $("#PageContainer").scroll($.throttle(15, containerScroll));
    var prevPos = 0;
    var stickyActive = false;

    function containerScroll() {
      var scroll = $("#PageContainer").scrollTop();
      var threshold = 112;
      var half_threshold = 100;
      var newPos = scroll;
      $siteHeader = $(".header-sticky-wrapper .site-header");

      if (scroll > threshold + 10) {
        $siteHeader.addClass('site-header--stuck-inactive');
      } else {
        $siteHeader.removeClass('site-header--stuck-inactive');
      }

      if (prevPos > scroll) {
        $siteHeader.addClass('drops');
        $('.free-shipping-bar').addClass('drops');
      } else {
        if (!$('.site-header--heading-style').hasClass('active-nav-icons-shop-all')) {
          if (!$('.site-header--heading-style').hasClass('active-nav-icons')) {
            $siteHeader.removeClass('drops');
            $('.free-shipping-bar').removeClass('drops');
          }
        }
      }

      prevPos = scroll;

      if (scroll > threshold) {
        if (stickyActive) {
          return;
        }

        stickyActive = true;
        $siteHeader.addClass('site-header--stuck'); // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly

        setTimeout(function () {
          $siteHeader.addClass('site-header--opening');
        }, 100);
      } else {
        if (!stickyActive) {
          return;
        }

        stickyActive = false;
        $siteHeader.removeClass('site-header--opening').removeClass('site-header--stuck');
      }

      lastScroll = scroll;
    }
  };

  theme.reinitializeSections = function () {
    window.sections = new theme.Sections();
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('product', theme.Product);
    sections.register('product-template', theme.Product);
  };

  setCookie('referrer-href', window.location.href);
})(theme.jQuery);

function findGetParameter(parameterName) {
  var result = null,
      tmp = [];
  location.search.substr(1).split("&").forEach(function (item) {
    tmp = item.split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  });
  return result;
}

cjevent = findGetParameter("cjevent");

if (cjevent) {
  var expires = "";
  var date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  expires = "; expires=" + date.toUTCString();
  document.cookie = 'cjevent' + "=" + (cjevent || "") + expires + "; path=/";
}

Currency.convertAll = function (c, b, a, d) {
  jQuery(a || "span.money").each(function () {
    if (jQuery(this).attr("data-currency") === b) {
      return;
    }

    cool = false;

    if (jQuery(this).attr("data-currency-" + b) && cool) {
      jQuery(this).html(jQuery(this).attr("data-currency-" + b));
    } else {
      var e = 0;
      var f = Currency[d || Currency.format][c] || "";
      var g = Currency[d || Currency.format][b] || "";

      if (f.indexOf("amount_no_decimals") !== -1) {
        e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) * 100, c, b);
      } else {
        if (c === "JOD" || c == "KWD" || c == "BHD") {
          e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) / 10, c, b);
        } else {
          e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), c, b);
        }
      }

      var h = Currency.formatMoney(e, g);

      if (jQuery(this).html().indexOf(c) >= 1) {
        if (h.indexOf(c) >= 1) {
          jQuery(this).html(h);
        } else {
          jQuery(this).html(h + " " + b);
        }
      } else {
        jQuery(this).html(h);
      }

      jQuery(this).attr("data-currency-" + b, h);
    }

    jQuery(this).attr("data-currency", b);
  });
  this.currentCurrency = b;
  this.cookie.write(b);
};